import bops from 'bops';

const decipherWallet = async (content, password) => {
  try {
    const hexContent = bops.from(content, 'hex');
    const iv = hexContent.slice(0, 12);
    const cipherText = hexContent.slice(12);
    const hash = await crypto.subtle.digest('SHA-256', bops.from(password));
    const key = await crypto.subtle.importKey('raw', hash, 'AES-GCM', true, [
      'decrypt',
    ]);
    const decipher = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      key,
      cipherText,
    );

    const decoded = new TextDecoder().decode(decipher);
    console.log(decoded);
    return JSON.parse(decoded);
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export default decipherWallet;
